export default __webpack_public_path__ + "static/media/Guru-Parampara-17.fedc681b.png";